import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../firebase/auth";
import { db } from "../firebase/firestore";
import { doc, onSnapshot } from "firebase/firestore";
import "./Navbar.css";
import { useCurrentUser } from "./useCurrentUser";

interface NavbarProps {
  onLogout: () => void;
}

export default function Navbar({ onLogout }: NavbarProps) {
  const { displayName } = useCurrentUser();
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Left: Names / Logo */}
        <div className="navbar-brand">
          {displayName || "Welcome"}
        </div>

        {/* Center: Navigation */}
        <div className="navbar-links">
          <Link to="/">Norsk</Link>
          <Link to="/English">English</Link>
          {/* <Link to="/page3">Profile</Link> */}
          {/* <Link to="/page4">Gallery</Link> */}
        </div>

        {/* Right: Logout */}
        <div className="navbar-actions">
          <button onClick={onLogout}>Logout</button>
        </div>
      </div>
    </nav>
  );
}
